var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondSuiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sui"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_15020)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0213,
    cy: 21.5328,
    rx: 22.0213,
    ry: 21.5328,
    transform: "matrix(0.971706 -0.236195 0.24777 0.968819 34.7188 45.4023)",
    fill: "#4DA2FF",
    fillOpacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_15020)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0213,
    cy: 21.5328,
    rx: 22.0213,
    ry: 21.5328,
    transform: "matrix(0.971706 -0.236195 0.24777 0.968819 34.7188 45.4023)",
    fill: "#4DA2FF",
    fillOpacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_15020)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.0213,
    cy: 21.5328,
    rx: 22.0213,
    ry: 21.5328,
    transform: "matrix(0.971706 -0.236195 0.24777 0.968819 34.7188 45.4023)",
    fill: "#4DA2FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.5411 47.433C65.5986 48.8846 67.6284 50.3734 69.721 51.7802C72.8522 53.8842 74.899 56.6599 75.4634 60.2693C76.2376 65.2088 74.5512 69.4162 70.3621 72.5923C63.9023 77.4909 54.6616 76.1662 50.2441 69.7249C47.6689 65.9639 47.2985 61.8499 49.2763 57.6835C51.3575 53.3018 53.6546 49.0055 55.8549 44.6703C56.0489 44.2877 56.1988 43.8839 56.4185 43.5168C56.6859 43.0684 57.0484 42.944 57.5277 43.2878C58.0756 43.6818 58.6524 44.0426 59.2143 44.4186C60.5974 45.4957 62.0416 46.5019 63.5411 47.433ZM52.7448 67.639L52.8761 67.8249C52.8912 67.8929 52.9842 67.997 53.0168 68.0591C56.1568 72.6689 63.5241 73.7172 68.1476 70.2234C68.4611 69.986 68.5935 69.7752 68.5094 69.3919C68.1705 67.8479 67.4074 66.5579 66.1185 65.5498C64.5571 64.3319 62.6982 63.712 60.7698 63.1962C57.9797 62.444 55.5198 61.2165 53.8755 58.8731C53.5295 58.3763 53.2363 57.8551 52.8726 57.2711C51.7033 59.1528 51.1159 61.0759 51.2688 63.1429C51.3933 64.7711 51.8136 66.1227 52.7448 67.639ZM71.2575 66.6038C71.4367 66.2785 71.5431 66.1176 71.6171 65.9456C72.4815 63.8926 72.6081 61.6424 71.9773 59.5425C71.3466 57.4425 69.9935 55.6097 68.1271 54.327C66.054 52.8995 63.9935 51.4487 61.9293 50.0074C60.8954 49.2838 59.8625 48.56 58.8306 47.8359C58.369 47.5125 57.8763 47.4014 57.5719 47.9778C56.8558 49.331 56.0592 50.6603 55.8552 52.194C55.5154 54.7453 56.0734 56.9694 58.3271 58.581C59.5283 59.4406 60.9287 59.9134 62.3771 60.2889C64.578 60.8619 66.6262 61.7247 68.4082 63.0763C69.6156 64.0027 70.522 65.1546 71.2575 66.6038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_15020",
    x: 0.094532,
    y: 0.258595,
    width: 122.717,
    height: 121.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_15020"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_15020",
    x: 0.094532,
    y: 0.258595,
    width: 122.717,
    height: 121.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_15020"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_15020",
    x: 0.094532,
    y: 0.258595,
    width: 122.717,
    height: 121.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_15020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSuiIcon);
export default __webpack_public_path__ + "static/media/SecondSuiIcon.9e36fa781a13dd96c26df1aa5ae68d43.svg";
export { ForwardRef as ReactComponent };